import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/AuthContext';
import AuthLayout from './AuthLayout';

export default function OAuthCallback() {
  const { handleOAuthCallback } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation('auth');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const provider = localStorage.getItem('ida_oauth_provider') || 'google';

    if (!code || !state) {
      setError(t('oauth.errorMissing'));
      return;
    }

    handleOAuthCallback(provider, code, state)
      .then(() => navigate('/dashboard', { replace: true }))
      .catch((err) => setError(err instanceof Error ? err.message : t('oauth.errorFailed')));
  }, []);

  return (
    <AuthLayout>
      {error ? (
        <div className="text-center">
          <span className="material-symbols-outlined text-red-500 mb-4" style={{ fontSize: 48 }}>error</span>
          <h2 className="text-xl font-bold text-text-main">{t('oauth.callbackFailed')}</h2>
          <p className="mt-2 text-sm text-red-600">{error}</p>
          <button onClick={() => navigate('/login')} className="btn-primary mt-6 w-full">{t('oauth.callbackBack')}</button>
        </div>
      ) : (
        <div className="flex flex-col items-center py-8">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary mb-4"></div>
          <p className="text-sm text-text-faint">{t('oauth.callbackCompleting')}</p>
        </div>
      )}
    </AuthLayout>
  );
}
